/**
 * 콘텍스트메뉴 대체
 */
import { SbsPlayerGlobal } from '../../../../common';
import '../Controls/PlayPause';
import '../Controls/Volume';

customElements.define(
  'sbs-player-ad-newwork-ad-controls',
  class extends HTMLElement {
    constructor() {
      super();
      this.visible = true;
      this.ended = false;
    }

    set visible(value) {
      this._visible = value;
      this.render();
    }

    get visible() {
      return this._visible;
    }

    static get observedAttributes() {
      return [];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    adoptedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        if (!this.visible) {
          this.style.display = 'none';
          return;
        }

        this.style.display = 'block';
        this.style.position = 'absolute';
        this.style.bottom = '0';
        this.style.left = '0';
        this.style.width = 'auto';
        this.style.zIndex = '1000';
        this.style.pointerEvents = 'auto';

        this.innerHTML = `
        <div class="playerControls_w" style="position: relative; width: auto; display: inline-block; padding: 10px; border-radius: 8px;">
          <div class="playerFunctionBtns">
            <div class="playerControls_left" style="display: flex; align-items: center; gap: 8px;">
              <sbs-player-ad-playpause></sbs-player-ad-playpause>
              <sbs-player-ad-volume></sbs-player-ad-volume>
            </div>
          </div>
        </div>`;
        this.event();
      } catch (error) {
        console.log(error);
      }
    }

    styles() {
      try {
      } catch (error) {
        console.error(error);
      }
    }

    event() {
      // 중복 이벤트 리스너 방지
      if (this._eventListenersAdded) return;
      this._eventListenersAdded = true;

      // 약간 딜레이를 두고 요소들을 찾음 (렌더링 완료 후)
      setTimeout(() => {
        const adPlayPause = this.querySelector('sbs-player-ad-playpause');
        const adVolume = this.querySelector('sbs-player-ad-volume');

        console.log('#### NetworkAdControls - Found elements:', {
          adPlayPause,
          adVolume,
        });

        // 초기 상태 설정
        if (adPlayPause) {
          adPlayPause.paused = false;
          console.log(
            '#### NetworkAdControls - Set initial paused state to false'
          );
        }

        if (adVolume) {
          // 초기 상태는 실제 비디오 상태를 반영
          const video = SbsPlayerGlobal.view.querySelector('video');
          const initialVolume = video ? video.volume * 100 : 0; // 0-1을 0-100으로 변환
          const initialMuted = video ? video.muted : true;

          adVolume.vol = initialVolume;
          adVolume.muted = initialMuted;

          // display 함수를 호출하여 즉시 UI 반영 (렌더링 완료 후)
          setTimeout(() => {
            if (typeof adVolume.display === 'function') {
              adVolume.display(initialVolume);
              console.log(
                '#### NetworkAdControls - Called display() for initial volume'
              );
            }
          }, 50);

          console.log(
            '#### NetworkAdControls - Set initial volume to',
            initialVolume,
            '%, muted',
            initialMuted
          );
        }

        // 광고 비디오 이벤트 리스너 (한 번만 추가)
        const videoChangeHandler = (event) => {
          try {
            console.log(
              '#### NetworkAdControls - video-change-ad event:',
              event.type
            );
            switch (event.type) {
              case 'play':
                if (adPlayPause) {
                  adPlayPause.paused = false;
                  console.log('#### NetworkAdControls - Set paused to false');
                }
                break;
              case 'pause':
                if (adPlayPause) {
                  adPlayPause.paused = true;
                  console.log('#### NetworkAdControls - Set paused to true');
                }
                break;
              case 'volumechange':
                if (adVolume && event.target) {
                  const volume = (event.target.volume || 0) * 100; // 0-1을 0-100으로 변환
                  const muted = event.target.muted || false;

                  // Volume 컴포넌트 업데이트
                  adVolume.vol = volume;
                  adVolume.muted = muted;

                  // display 함수를 직접 호출하여 즉시 UI 반영
                  setTimeout(() => {
                    if (typeof adVolume.display === 'function') {
                      adVolume.display(volume);
                      console.log(
                        '#### NetworkAdControls - Called display() for volume change'
                      );
                    }
                  }, 10);

                  console.log(
                    '#### NetworkAdControls - Set volume:',
                    volume,
                    'muted:',
                    muted,
                    'and triggered display()'
                  );
                }
                break;
            }
          } catch (error) {
            console.log(
              '#### NetworkAdControls - video-change-ad error:',
              error
            );
          }
        };

        SbsPlayerGlobal.events.addEventListener(
          'video-change-ad',
          videoChangeHandler
        );
        this._videoChangeHandler = videoChangeHandler;

        // 컨트롤러 요소들의 이벤트 리스너 (중복 방지 및 디바운싱)
        if (adPlayPause && !adPlayPause._networkControlsListener) {
          let playPauseTimeout;
          const playPauseHandler = (e) => {
            e.stopPropagation(); // 이벤트 버블링 방지
            clearTimeout(playPauseTimeout);
            playPauseTimeout = setTimeout(() => {
              console.log(
                `#### NetworkAdControls - button-toggle-playpause triggered with detail:`,
                e.detail
              );

              // 버튼 클릭 시 볼륨을 0.5로 설정하고 뮤트 해제
              const video = SbsPlayerGlobal.view.querySelector('video');
              if (video) {
                video.volume = 0.5;
                video.muted = false;
                console.log(
                  '#### NetworkAdControls - Set volume to 0.5 and unmuted on play/pause click'
                );
              }

              SbsPlayerGlobal.events.emitEvent(
                'button-toggle-playpause',
                e.detail
              );
            }, 50); // 50ms 디바운싱
          };
          adPlayPause.addEventListener(
            'button-toggle-playpause',
            playPauseHandler
          );
          adPlayPause._networkControlsListener = true;
          adPlayPause._playPauseHandler = playPauseHandler; // cleanup을 위해 저장
          console.log(
            '#### NetworkAdControls - Added listener for button-toggle-playpause'
          );
        }

        if (adVolume && !adVolume._networkControlsListener) {
          let volumeTimeout, muteTimeout;

          // 볼륨 변경 이벤트
          const volumeHandler = (e) => {
            e.stopPropagation(); // 이벤트 버블링 방지
            clearTimeout(volumeTimeout);
            volumeTimeout = setTimeout(() => {
              console.log(
                `#### NetworkAdControls - input-change-volume triggered with detail:`,
                e.detail
              );

              SbsPlayerGlobal.events.emitEvent('input-change-volume', e.detail);
            }, 100); // 100ms 디바운싱 (볼륨은 좀 더 길게)
          };

          // 음소거 토글 이벤트
          const muteToggleHandler = (e) => {
            e.stopPropagation(); // 이벤트 버블링 방지
            clearTimeout(muteTimeout);
            muteTimeout = setTimeout(() => {
              console.log(
                `#### NetworkAdControls - button-toggle-volume triggered with detail:`,
                e.detail
              );
              SbsPlayerGlobal.events.emitEvent(
                'button-toggle-volume',
                e.detail
              );
            }, 50); // 50ms 디바운싱
          };

          adVolume.addEventListener('input-change-volume', volumeHandler);
          adVolume.addEventListener('button-toggle-volume', muteToggleHandler);
          adVolume._networkControlsListener = true;
          adVolume._volumeHandler = volumeHandler; // cleanup을 위해 저장
          adVolume._muteToggleHandler = muteToggleHandler; // cleanup을 위해 저장
          console.log(
            '#### NetworkAdControls - Added listeners for input-change-volume and button-toggle-volume'
          );
        }
      }, 100);
    }

    disconnectedCallback() {
      try {
        // 이벤트 리스너 정리
        if (this._videoChangeHandler) {
          SbsPlayerGlobal.events.removeEventListener(
            'video-change-ad',
            this._videoChangeHandler
          );
        }

        // 개별 컨트롤 이벤트 리스너 정리
        const adPlayPause = this.querySelector('sbs-player-ad-playpause');
        const adVolume = this.querySelector('sbs-player-ad-volume');

        if (adPlayPause && adPlayPause._playPauseHandler) {
          adPlayPause.removeEventListener(
            'button-toggle-playpause',
            adPlayPause._playPauseHandler
          );
          adPlayPause._networkControlsListener = false;
          delete adPlayPause._playPauseHandler;
        }

        if (adVolume && adVolume._volumeHandler) {
          adVolume.removeEventListener(
            'input-change-volume',
            adVolume._volumeHandler
          );
          if (adVolume._muteToggleHandler) {
            adVolume.removeEventListener(
              'button-toggle-volume',
              adVolume._muteToggleHandler
            );
            delete adVolume._muteToggleHandler;
          }
          adVolume._networkControlsListener = false;
          delete adVolume._volumeHandler;
        }

        this._eventListenersAdded = false;
      } catch (error) {
        console.log(
          '#### NetworkAdControls - disconnectedCallback error:',
          error
        );
      }
    }
  }
);
